import { render, staticRenderFns } from "./EstimateFlatButton.vue?vue&type=template&id=4ca60312&scoped=true&"
import script from "./EstimateFlatButton.vue?vue&type=script&lang=js&"
export * from "./EstimateFlatButton.vue?vue&type=script&lang=js&"
import style0 from "./EstimateFlatButton.vue?vue&type=style&index=0&id=4ca60312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca60312",
  null
  
)

export default component.exports